/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as GlobalService from "../react/global_services";
import "./parcel-shipments-tracking-details.scss";
import WmsCollapse from "../react/components/WmsCollapse/WmsCollapse";
import WmsTable from "../react/components/WmsTable/WmsTable";

interface Props {
    wmsSelector: string;
    trackingInfo: any;
    onExitShipmentDetails: () => void;
    windowId: string;
}
declare var window: any;

const ParcelShipmentsTrackingDetails: React.FC<Props> = (props: Props): any => {
    const [carrierLogoUrl, setCarrierLogoUrl] = useState("assets/images/3PL_Logo_Orange.png");
    const [statusName, setStatusName] = useState("Label Created");

    // Date format constant to avoid duplication
    const DATE_FORMAT = "MMM DD YYYY, hh:mm:ss A";

    // Helper function to format dates safely
    const formatDate = (date: any): string => {
        if (date) {
            var dateStr = date;
            // Remove 'Z' from dateStr if it exists (treat as local/warehouse time, not UTC)
            dateStr = dateStr.replace("Z", "");
            var timeStr = dateStr.includes("T") ? dateStr.split("T")[1] : dateStr.split(" ")[1] || "00:00:00";
            if (timeStr.startsWith("00:00:00")) {
                return (window as any).moment(dateStr).format("MMM DD YYYY");
            } else {
                // Convert from PDT to local browser timezone for non-midnight times
                // Parse the date string and treat it as PDT (UTC-7)
                var isoDateStr = dateStr.replace(" ", "T");
                // var pdtMoment = (window as any).moment(isoDateStr).utcOffset(-7, true);
                // return pdtMoment.local().format("MMM DD YYYY hh:mm A");
                return (window as any).moment(isoDateStr).format(DATE_FORMAT);
            }
        }
        return "";
    };

    useEffect(() => {
        if (props.trackingInfo?.TrackingInfo) {
            // Set carrier logo
            const carrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();
            let carrierName = props.trackingInfo?.TrackingInfo?.carrier || "";
            let carrierCode = props.trackingInfo?.TrackingInfo?.carrierCode || "";
            // Check if carrier is USPS and set carrierCode to usps
            if (carrierName === "USPS") {
                carrierCode = "usps";
            }
            if (carrierAccountSchema && carrierCode) {
                setCarrierLogoUrl("assets/images/3PL_Logo_Orange.png");
                for (const providerName in carrierAccountSchema) {
                    const tmpCarriers = carrierAccountSchema[`${providerName}`].carriers;
                    for (const carrier in tmpCarriers) {
                        if (carrierCode === carrier) {
                            setCarrierLogoUrl(tmpCarriers[`${carrier}`].logo);
                            break;
                        }
                    }
                }
            }

            // Set status name
            const deliveryStatus = props.trackingInfo.TrackingInfo.deliveryStatus;
            if (deliveryStatus === "delivered") {
                setStatusName("Delivered");
            } else if (deliveryStatus === "accepted") {
                setStatusName("Accepted");
            } else if (deliveryStatus === "inTransit") {
                setStatusName("In Transit");
            } else if (deliveryStatus === "exception") {
                setStatusName("Exception");
            } else if (deliveryStatus === "unknown") {
                setStatusName("Unknown");
            } else {
                setStatusName("Label Created");
            }
        }
    }, [props.trackingInfo]);

    return (
        <div className="parcel-shipments-tracking-details-wrapper">
            <div className="shipment-details-card">
                {/* Gray Header Bar */}
                <div className="gray-header-bar">
                    <div className="header-controls">
                        <div className="close-btn" onClick={props.onExitShipmentDetails}></div>
                    </div>
                </div>

                {/* Scrollable Content Container */}
                <div className="scrollable-content">
                    {/* Carrier Logo and Delivery Info Section */}
                    <div className="carrier-info-section">
                        <div className="carrier-logo-container">
                            <img
                                src={carrierLogoUrl}
                                alt={props.trackingInfo?.TrackingInfo?.carrier}
                                className="carrier-logo-img"
                            />
                        </div>
                        <div className="delivery-info">
                            <div className="delivery-status">
                                <span className={`status-badge ${props.trackingInfo?.TrackingInfo?.deliveryStatus}`}>
                                    {statusName}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Service and Date Line */}
                    <div className="service-date-line">
                        <div className="service-info">
                            <span className="service-label">{window.translate("Label_Service")}:</span>
                            <span className="service-name">{props.trackingInfo?.TrackingInfo?.shipService}</span>
                        </div>
                        <div className="delivery-time">
                            {props.trackingInfo?.TrackingInfo?.trackingUpdateDate
                                ? window
                                .moment(props.trackingInfo?.TrackingInfo?.trackingUpdateDate)
                                    .format(DATE_FORMAT)
                                : window.moment().format(DATE_FORMAT)}
                        </div>
                    </div>

                    {/* Transaction Details Section */}
                    <div className="content-section-wrapper">
                    <WmsCollapse
                        id="transactionDetails"
                        headerLabel={window.translate("Label_Transaction_Details")}
                        showCollapseText={false}
                    >
                        <div className="info-grid">
                            <div className="info-item">
                                <label>{window.translate("FindOrders_Lbl_Customer")}:</label>
                                <span>{props.trackingInfo?.TrackingInfo?.customer}</span>
                            </div>
                            <div className="info-item">
                                <label>{window.translate("Orders_Lbl_Transaction_Id")}:</label>
                                <span>{props.trackingInfo?.TrackingInfo?.transactionId}</span>
                            </div>
                            <div className="info-item">
                                <label>{window.translate("Label_Warehouse_Text")}:</label>
                                <span>{props.trackingInfo?.TrackingInfo?.warehouse}</span>
                            </div>
                            <div className="info-item">
                                <label>{window.translate("Label_Package_Id")}:</label>
                                <span>{props.trackingInfo?.TrackingInfo?.packageId}</span>
                            </div>
                        </div>
                    </WmsCollapse>
                </div>

                    {/* Shipment Details Section with Two Column Layout */}
                    <div className="content-section-wrapper">
                    <WmsCollapse
                        id="shipmentDetails"
                        headerLabel={window.translate("Label_Shipment_Details")}
                        showCollapseText={false}
                    >
                        <div className="tracking-info-grid">
                            {/* Left Column */}
                            <div className="tracking-info-left">
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Tracking_Number")}:</label>
                                    {props.trackingInfo?.TrackingInfo?.trackingUrl ? (
                                        <a
                                            href={props.trackingInfo.TrackingInfo.trackingUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="tracking-link"
                                        >
                                            {props.trackingInfo.TrackingInfo.trackingNumber}
                                        </a>
                                    ) : (
                                        <span className="tracking-link">
                                            {props.trackingInfo?.TrackingInfo?.trackingNumber}
                                        </span>
                                    )}
                                </div>
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Estimated_Delivery")}:</label>
                                    <span>{formatDate(props.trackingInfo?.TrackingInfo?.estimatedDeliveryDate)}</span>
                                </div>
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Actual_Delivery")}:</label>
                                    <span>{formatDate(props.trackingInfo?.TrackingInfo?.actualDeliveryDate)}</span>
                                </div>
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Filter_Ship_To")}:</label>
                                    <span>
                                        {props.trackingInfo?.TrackingInfo?.shipTo.address1}
                                        {props.trackingInfo?.TrackingInfo?.shipTo.city &&
                                            `, ${props.trackingInfo.TrackingInfo.shipTo.city}`}
                                        {props.trackingInfo?.TrackingInfo?.shipTo.state &&
                                            `, ${props.trackingInfo.TrackingInfo.shipTo.state}`}
                                        {props.trackingInfo?.TrackingInfo?.shipTo.zip &&
                                            `, ${props.trackingInfo.TrackingInfo.shipTo.zip}`}
                                        {props.trackingInfo?.TrackingInfo?.shipTo.country &&
                                            `, ${props.trackingInfo.TrackingInfo.shipTo.country}`}
                                    </span>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="tracking-info-right">
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Status_Code")}:</label>
                                    <span>{props.trackingInfo?.TrackingInfo?.statusCode}</span>
                                </div>
                                <div className="tracking-info-item">
                                    <label>{window.translate("Label_Status_Description")}:</label>
                                    <span>{props.trackingInfo?.TrackingInfo?.statusDescription}</span>
                                </div>
                            </div>
                        </div>
                    </WmsCollapse>
                </div>
                    {/* SKUs Section */}
                    <div className="section-header">
                    <span className="sku-title">{window.translate("Label_Filter_Sku")}</span>
                </div>
                    <div className="section-content">
                    <WmsTable
                        data={props.trackingInfo?.TrackingInfo?.packageItems || []}
                        columns={[
                            {
                                field: "sku",
                                title: window.translate("Label_Sku"),
                                width: 120,
                            },
                            {
                                field: "itemDescription",
                                title: window.translate("Label_Description"),
                                width: 200,
                            },
                            {
                                field: "qty",
                                title: window.translate("Label_Quantity"),
                                width: 100,
                            },
                        ]}
                    />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParcelShipmentsTrackingDetails;
